import {ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import config from '../../../config';
import {Contract} from "../../../classes/contract";
import {kanContract} from "../components/contract/component";

@Injectable()
export class kanContractsService {
    constructor(private http: HttpClient,
                private componentFactoryResolver: ComponentFactoryResolver,
                private appRef: ApplicationRef,
                private injector: Injector) {
    }

    public showContract(contractId, userId, dogId) {

        this.getContract(contractId)
            .then((contract) => {

                let componentRef = this.componentFactoryResolver
                    .resolveComponentFactory(kanContract)
                    .create(this.injector);

                this.appRef.attachView(componentRef.hostView);

                const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
                    .rootNodes[0] as HTMLElement;

                document.body.appendChild(domElem);

                componentRef.instance.setData(contract, userId, dogId);
            });
    }

    public getContracts(): Promise<Contract[]> {
        return new Promise((resolve, reject) => {

            this.http.get(`${config.apiRootUrl}/api/contracts`)
                .toPromise()
                .then((response: any) => {

                    resolve(response as Contract[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public getContract(id: string): Promise<Contract> {
        return new Promise((resolve, reject) => {

            this.http.get(`${config.apiRootUrl}/api/contracts/${id}`)
                .toPromise()
                .then((response: any) => {

                    resolve(response as Contract);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public addContract(contract: Contract): Promise<Contract> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/contracts`, contract)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Contract);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public updateContract(contract: Contract): Promise<Contract> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/contracts/${contract.id}`, contract)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Contract);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public removeContract(contract: Contract): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/contracts/${contract.id}`, {})
                .toPromise()
                .then((response: any) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/contracts.ts